import {DiffLineType, DiffLineTypeCharacter} from '@github-ui/diffs/types'
import type {DiffHunkAgentReference} from '@github-ui/generate-commit-message'

import {AutomatedCommentSource, SuggestionStates, type AutomatedComment, type DiffEntry} from '../conversation-types'

export function isSuggestionCommitMessageGenerationEligible(comment: AutomatedComment | null | undefined): boolean {
  return (
    comment?.source === AutomatedCommentSource.Copilot &&
    comment.suggestionState === SuggestionStates.Present &&
    !comment.isDismissed &&
    comment.commitMessageGenerationConfig !== null
  )
}

function serializeDiffEntryForPrompt({diffLines}: DiffEntry): string {
  const hasChangedLine = diffLines.some(
    line => line.type === DiffLineType.Addition || line.type === DiffLineType.Deletion,
  )
  if (!hasChangedLine) return ''

  return diffLines
    .flatMap(line => {
      // DiffEntry text is marker-free source, so prefix it without interpreting its first character.
      if (
        line.type !== DiffLineType.Addition &&
        line.type !== DiffLineType.Context &&
        line.type !== DiffLineType.Deletion
      ) {
        return []
      }

      return [`${DiffLineTypeCharacter[line.type]}${line.text}`]
    })
    .join('\n')
}

/**
 * Builds the `github.diff-hunk` references required by commit-message generation. CAPI uses each
 * diff as prompt context, so this restores body markers without rebuilding a git-apply-able patch.
 */
export function createDiffHunkReferencesFromEntries(diffEntries: DiffEntry[]): DiffHunkAgentReference[] {
  return diffEntries.flatMap(entry => {
    const diff = serializeDiffEntryForPrompt(entry)
    if (!diff) return []

    return [
      {
        type: 'github.diff-hunk' as const,
        data: {
          type: 'diff-hunk' as const,
          changeReference: '',
          fileName: entry.path,
          headerContext: '',
          diff,
        },
      },
    ]
  })
}
